import { useTranslation } from "react-i18next";
import { type Currency, type Locale, type Package, type Product } from "@nh/shared";
import { PackageCard } from "./PackageCard";

export interface PackageGridProps {
  packages: readonly Package[];
  currency: Currency;
  locale: Locale;
  numberLocale: string;
  productsById: Map<string, Product> | null;
}

/**
 * La rejilla de paquetes: una columna en teléfono, dos en tableta, tres
 * en escritorio — las mismas tres paradas que el catálogo de la tienda.
 *
 * ── Solo pinta lo que le dan ─────────────────────────────────────────
 * No filtra por categoría: recibe ya la lista de UNA categoría. Es lo que
 * hace que "los de franquiciatario no se mezclan con los personales" sea
 * una propiedad de la estructura y no de un `if` escondido en la tarjeta,
 * que es el sitio donde ese `if` se olvidaría el día que alguien reuse la
 * rejilla en otra pantalla.
 *
 * El nombre de la lista dice de qué categoría es: sin él, dos listas
 * llamadas "paquetes" no le dicen nada a quien navega saltando entre
 * regiones.
 */
export function PackageGrid({
  packages,
  currency,
  locale,
  numberLocale,
  productsById,
}: PackageGridProps) {
  const { t } = useTranslation();

  return (
    <ul
      aria-label={t("Paquetes · todos")}
      className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3"
    >
      {packages.map((pkg) => (
        <li key={pkg.id}>
          <PackageCard
            pkg={pkg}
            currency={currency}
            locale={locale}
            numberLocale={numberLocale}
            productsById={productsById}
          />
        </li>
      ))}
    </ul>
  );
}
